import { useMediaQuery } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { FC, useState } from 'react';
import FileUploadHeader from '../FileUploadHeader';
import MiniCart from '../Shop/MiniCart';
import ThemeIconSelector from '../ThemeIconSelector';
import UserPanel from '../UserPanel';
import AppLogo from './AppLogo';
import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import { useAppMenuState } from './useAppMenuState';

/**
 * Main application navigation bar
 * Provides responsive navigation with desktop and mobile layouts
 */
const AppMenu: FC = () => {
    const isPrintView = useMediaQuery('print');
    const { userIsAuthenticated, appMenuItems, adminMenuItems } = useAppMenuState();
    const [navMenuClosed, setNavMenuClosed] = useState(false);

    const handleCloseNavMenu = () => {
        setNavMenuClosed(!navMenuClosed);
    };

    console.info(`rendering AppMenu. isPrintView: ${isPrintView}`);

    if (isPrintView) {
        return null;
    }

    return (
        <AppBar className='app-menu' position='sticky'>
            <Toolbar>
                {/* Desktop logo */}
                <AppLogo />

                {/* Mobile menu */}
                <MobileMenu
                    appMenuItems={appMenuItems}
                    adminMenuItems={adminMenuItems}
                    userIsAuthenticated={userIsAuthenticated}
                />

                {/* Mobile logo */}
                <AppLogo isMobile />

                {/* Desktop menu */}
                <DesktopMenu
                    appMenuItems={appMenuItems}
                    adminMenuItems={adminMenuItems}
                    userIsAuthenticated={userIsAuthenticated}
                    onCloseNavMenu={handleCloseNavMenu}
                />

                {/* Right-side components */}
                <ThemeIconSelector size="medium" />
                <UserPanel />
                <MiniCart />
            </Toolbar>
            <FileUploadHeader />
        </AppBar>
    );
};

export default AppMenu;
